module.exports = __webpack_public_path__ + "static/media/bomb-1.3480643c.glb";